import React from 'react';
import {
  fetchPartnerIds,
  PartnerIdsResponse,
} from '../../modules/AnchorAPI/user/fetchPartnerIds';
import { getCurrentUser } from '../../user';
import { State } from './types';

const { useEffect, useReducer } = React;
const FETCH = 'FETCH';
const RECEIVE_USER = 'RECEIVE_USER';
const FETCH_USER_FAILED = 'FETCH_USER_FAILED';
const RESET = 'RESET';
const RECEIVE_PARTNER_IDS = 'RECEIVE_PARTNER_IDS';

const initialState: State = {
  userId: null,
  webStationId: null,
  status: 'idle',
  imageUrl: null,
  partnerIds: {
    optimizely: undefined,
    mParticle: undefined,
  },
};

type Action =
  | { type: typeof FETCH }
  | { type: typeof RECEIVE_USER; payload: CurrentUserResponse }
  | {
      type: typeof RECEIVE_PARTNER_IDS;
      payload: PartnerIdsResponse;
    }
  | { type: typeof RESET }
  | { type: typeof FETCH_USER_FAILED; error: string };

const reducer = (state: State, action: Action): State => {
  switch (action.type) {
    case FETCH:
      return { ...state, status: 'loading', error: undefined };
    case RECEIVE_USER: {
      // if we have user data, set that into state
      if (action.payload && action.payload.user) {
        const {
          payload: {
            user: { userId, stationId: webStationId, name, imageUrl },
          },
        } = action;
        return {
          ...state,
          userId,
          webStationId,
          name,
          imageUrl,
          status: 'success',
        };
      }
      return { ...state, status: 'success' };
    }
    case RECEIVE_PARTNER_IDS: {
      const { optimizely, mParticle } = action.payload;
      return {
        ...state,
        partnerIds: {
          optimizely,
          mParticle,
        },
      };
    }
    case FETCH_USER_FAILED:
      return {
        ...state,
        error: action.error,
        status: 'error',
      };
    case RESET:
      return initialState;
    default:
      return state;
  }
};

type CurrentUserResponse = {
  user?: {
    imageUrl: string | null;
    name: string;
    networkRoleUserId: number;
    stationId: string;
    userId: number;
  };
};

const useCurrentUser = () => {
  const [state, dispatch] = useReducer(reducer, initialState);
  const fetchCurrentUser = async () => {
    dispatch({ type: FETCH });
    try {
      const currentUserResponse: CurrentUserResponse = await getCurrentUser();
      dispatch({
        type: RECEIVE_USER,
        payload: currentUserResponse,
      });

      const userId = currentUserResponse.user
        ? currentUserResponse.user.userId
        : null;
      if (userId) {
        const res = await fetchPartnerIds(userId);
        dispatch({
          type: RECEIVE_PARTNER_IDS,
          payload: res,
        });
      }
    } catch (err) {
      const message = err.message ? err.message : '';
      dispatch({
        type: FETCH_USER_FAILED,
        error: `Failed to getCurrentUser ${message}`,
      });
    }
  };

  useEffect(() => {
    fetchCurrentUser();
  }, []);
  function resetCurrentUser() {
    dispatch({ type: RESET });
  }
  return { state, dispatch, fetchCurrentUser, resetCurrentUser };
};

export { useCurrentUser };
